import React, { createContext, useState, useEffect, useContext } from 'react';
import axiosInstance from '../config/axios';
import { AuthContext } from './AuthContext';

export const DevisContext = createContext();

export const DevisProvider = ({ children }) => {
  const { user, token } = useContext(AuthContext);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchUnreadCount = async () => {
    if (!user || !token) {
      setUnreadCount(0);
      return;
    }

    try {
      const response = await axiosInstance.get('/api/devis/unread-count');
      setUnreadCount(response.data.unread_count || 0);
    } catch (error) {
      console.error('Error fetching unread count:', error);
    }
  };

  useEffect(() => {
    if (user && token) {
      // Fetch immediately when user logs in
      fetchUnreadCount();
      
      // Set up polling every 10 seconds
      const interval = setInterval(() => {
        fetchUnreadCount();
      }, 10000); // Poll every 10 seconds

      return () => clearInterval(interval);
    } else {
      setUnreadCount(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, token]);

  const markAsRead = async (devisId) => {
    try {
      await axiosInstance.put(`/api/devis/${devisId}/mark-read`);
      // Update count immediately
      setUnreadCount(prev => Math.max(0, prev - 1));
      return { success: true };
    } catch (error) {
      console.error('Error marking devis as read:', error);
      return { success: false, error: error.response?.data?.error || 'Erreur lors du marquage comme lu' };
    }
  };

  const refreshCount = () => {
    fetchUnreadCount();
  };

  return (
    <DevisContext.Provider value={{ unreadCount, markAsRead, refreshCount, loading }}>
      {children}
    </DevisContext.Provider>
  );
};

